module.exports = __webpack_public_path__ + "static/media/pic5.4cc564cd.jpg";